import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Gallery from "@/components/site/Gallery";
import CustomCakes from "@/components/site/CustomCakes";
import Pricing from "@/components/site/Pricing";
import Flavors from "@/components/site/Flavors";
import Process from "@/components/site/Process";
import InquiryForm from "@/components/site/InquiryForm";
import About from "@/components/site/About";
import InstagramSection from "@/components/site/InstagramSection";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";
import StickyCTA from "@/components/site/StickyCTA";

const Home = () => (
  <main id="top">
    <Hero />
    <Marquee />
    <Gallery />
    <CustomCakes />
    <Pricing />
    <Flavors />
    <Process />
    <InquiryForm />
    <About />
    <InstagramSection />
    <FAQ />
    <FinalCTA />
  </main>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-[#FDFBF7] text-[#2D2422]">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
        <Footer />
        <StickyCTA />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
